import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeleteFertilizationPlanReference = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (id: string) => {
			try {
				const { data } = await api.delete(`/fertilization-plan-reference/delete/${id}`);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao excluir plano de cálculo');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fertilization-plan-reference'] }),
		onError: error =>
			console.error('Erro ao excluir plano de cálculo:', getApiErrorMessage(error, 'Erro ao excluir plano de cálculo')),
	});
};
